import { Typography } from "@mui/material";
import { pluralize } from "~/lib/pluralize";
import { Flex } from "~/components/Flex";

interface Props {
  count: number;
  totalCount: number;
}

export const TriageToolbarSelection = ({ count, totalCount }: Props) => {
  return (
    <Flex alignItems="center">
      <Typography
        fontWeight="bold"
        sx={{ mr: 4 }}
        color="common.white"
        gap={0.5}
      >
        <Typography component="span" fontWeight="bold" sx={{ fontSize: 24 }}>
          {count} /{" "}
        </Typography>
        {totalCount} {pluralize("item", totalCount || 0)} selected
      </Typography>
    </Flex>
  );
};
